"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactPopper = require("react-popper");

var _classnames = _interopRequireDefault(require("classnames"));

var _forma36Tokens = _interopRequireDefault(require("@contentful/forma-36-tokens"));

var _Portal = require("../Portal");

var _excluded = ["children", "className", "containerElement", "content", "id", "isVisible", "hideDelay", "onBlur", "onFocus", "onMouseLeave", "onMouseOver", "targetWrapperClassName", "maxWidth", "testId", "place", "usePortal"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = {
  "Tooltip__target-wrapper": "Tooltip__Tooltip__target-wrapper___Mtw42",
  "Tooltip": "Tooltip__Tooltip___32xAi",
  "Tooltip--hidden": "Tooltip__Tooltip--hidden___3uqEe",
  "TooltipContainer": "Tooltip__TooltipContainer___3YlPf",
  "Tooltip__arrow": "Tooltip__Tooltip__arrow___JuQmJ"
};

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$containerElement = _ref.containerElement,
      ContainerElement = _ref$containerElement === void 0 ? 'span' : _ref$containerElement,
      content = _ref.content,
      id = _ref.id,
      _ref$isVisible = _ref.isVisible,
      isVisible = _ref$isVisible === void 0 ? false : _ref$isVisible,
      _ref$hideDelay = _ref.hideDelay,
      hideDelay = _ref$hideDelay === void 0 ? 0 : _ref$hideDelay,
      _onBlur = _ref.onBlur,
      _onFocus = _ref.onFocus,
      _onMouseLeave = _ref.onMouseLeave,
      onMouseOver = _ref.onMouseOver,
      targetWrapperClassName = _ref.targetWrapperClassName,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? 360 : _ref$maxWidth,
      _ref$testId = _ref.testId,
      testId = _ref$testId === void 0 ? 'cf-ui-tooltip' : _ref$testId,
      _ref$place = _ref.place,
      place = _ref$place === void 0 ? 'auto' : _ref$place,
      _ref$usePortal = _ref.usePortal,
      usePortal = _ref$usePortal === void 0 ? false : _ref$usePortal,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var elementRef = (0, _react.useRef)(null);
  var popperRef = (0, _react.useRef)(null);

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      arrowRef = _useState4[0],
      setArrowRef = _useState4[1];

  var _usePopper = (0, _reactPopper.usePopper)(elementRef.current, popperRef.current, {
    placement: place,
    modifiers: [{
      name: 'arrow',
      options: {
        element: arrowRef,
        padding: parseFloat(_forma36Tokens["default"].borderRadiusSmall)
      }
    }, {
      name: 'offset',
      options: {
        offset: [0, 10]
      }
    }]
  }),
      popperStyles = _usePopper.styles,
      attributes = _usePopper.attributes,
      update = _usePopper.update; // necessary to update tooltip position in case the content is being updated


  (0, _react.useEffect)(function () {
    var updatePosition = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(update !== null)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return update();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function updatePosition() {
        return _ref2.apply(this, arguments);
      };
    }();

    updatePosition();
  }, [content, update]);

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      isHoveringTarget = _useState6[0],
      setIsHoveringTarget = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      isHoveringContent = _useState8[0],
      setIsHoveringContent = _useState8[1];

  (0, _react.useEffect)(function () {
    setShow(isHoveringContent || isHoveringTarget);
  }, [isHoveringTarget, isHoveringContent]);
  (0, _react.useEffect)(function () {
    if (isVisible) setShow(true); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var contentMaxWidth = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");

  var contentStyles = _objectSpread({
    zIndex: _forma36Tokens["default"].zIndexTooltip,
    maxWidth: contentMaxWidth
  }, popperStyles.popper);

  if (!content) {
    return /*#__PURE__*/_react["default"].createElement(ContainerElement, {
      className: targetWrapperClassName
    }, children);
  }

  var tooltip = /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({
    id: id,
    ref: popperRef,
    role: "tooltip",
    style: contentStyles,
    className: (0, _classnames["default"])(styles.Tooltip, className),
    "data-test-id": testId,
    onMouseEnter: function onMouseEnter() {
      setIsHoveringContent(true);
    },
    onMouseLeave: function onMouseLeave() {
      setIsHoveringContent(false);
    }
  }, attributes.popper), /*#__PURE__*/_react["default"].createElement("span", null, content), /*#__PURE__*/_react["default"].createElement("span", {
    className: styles['Tooltip__arrow'],
    "data-placement": attributes.popper && attributes.popper['data-popper-placement'],
    ref: setArrowRef,
    style: popperStyles.arrow
  }));

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(ContainerElement, (0, _extends2["default"])({
    ref: elementRef,
    className: (0, _classnames["default"])(styles.TooltipContainer, targetWrapperClassName),
    onMouseEnter: function onMouseEnter(evt) {
      setIsHoveringTarget(true);
      if (onMouseOver) onMouseOver(evt);
    },
    onMouseLeave: function onMouseLeave(evt) {
      setTimeout(function () {
        return setIsHoveringTarget(false);
      }, hideDelay);
      if (_onMouseLeave) _onMouseLeave(evt);
    },
    onFocus: function onFocus(evt) {
      setIsHoveringTarget(true);
      if (_onFocus) _onFocus(evt);
    },
    onBlur: function onBlur(evt) {
      setTimeout(function () {
        return setIsHoveringTarget(false);
      }, hideDelay);
      if (_onBlur) _onBlur(evt);
    }
  }, otherProps), children), show ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, usePortal ? /*#__PURE__*/_react["default"].createElement(_Portal.Portal, null, tooltip) : tooltip) : null);
};

exports.Tooltip = Tooltip;